module.exports = __webpack_public_path__ + "static/img/data.6831e4f2.png";